import { render } from "./MyAds.vue?vue&type=template&id=886d92ee&scoped=true"
import script from "./MyAds.vue?vue&type=script&lang=js"
export * from "./MyAds.vue?vue&type=script&lang=js"

import "./MyAds.vue?vue&type=style&index=0&id=886d92ee&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-886d92ee"]])

export default __exports__